import React from "react";
import styled from "styled-components";
import palette from "../../../styles/palette";
import DateFrom from "../../Date/DateFrom";
import PlayerLink from "../../Player/PlayerLink";

const MessageWrapper = styled.div`
  margin: 2px;
`;

const Info = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 1px;

  & > *:last-child {
    font-size: 0.8em;
    margin-left: 0.5rem;
    color: #777;
  }
`;

const DisplayMessage = styled.div<{
  myTeam?: boolean;
  mine?: boolean;
}>`
  background-color: ${(props) =>
    props.myTeam
      ? props.mine
        ? palette.primary.dark
        : palette.primary.light
      : props.mine
      ? palette.secondary.dark
      : palette.secondary.light};
  border-radius: 5px;
  color: ${palette.primary.contrastText};
  display: inline-block;
  font-size: 0.9em;
  margin-left: 2em;
  padding: 3px 1em;
`;

type MessageProps = {
  message: any;
  player: any;
  withInfo: boolean;
  team: any;
};

const Message: React.FC<MessageProps> = React.memo(
  ({ message, player, withInfo, team }) => {
    return (
      <MessageWrapper>
        {withInfo && (
          <Info>
            <PlayerLink player={message.player} horizontal={true} />
            <DateFrom>{message.createdAt}</DateFrom>
          </Info>
        )}
        <DisplayMessage
          mine={player && player.id === message.player.id}
          myTeam={team?.id === message.player?.teamId}
        >
          {message.message}
        </DisplayMessage>
      </MessageWrapper>
    );
  }
);

export default Message;
